import { BaseService } from '../../../infra/base.service'
import type { FormTemplate } from './form-template'
import type { FormTemplatesRepository } from './form-templates.repository'

export class FormTemplatesService extends BaseService<FormTemplate> {
    constructor(private rep: FormTemplatesRepository) {
        super(rep)
    }

    async copy(formTemplateId: string) {
        return await this.rep.copy(formTemplateId)
    }

    async addModels() {
        return await this.rep.addModels()
    }
}
